<script>
    import { projectSettings } from '../config';
</script>

<a class="ca-phone-link" target="_blank" href="tel:{projectSettings.phoneNumber}" title="Call {projectSettings.phoneNumber}">
    <span style="white-space:nowrap">{projectSettings.phoneNumber}</span>
</a>
